import {Component, Inject} from '@angular/core';
import {saveAs} from 'file-saver';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ConfirmDialogComponent} from '../../services/confirm-dialog-service/confirm-dialog/confirm-dialog.component';
import {ApiErrorResponse} from '../../services/api/api.service';

@Component({
    selector: 'app-file-upload-fail-dialog',
    templateUrl: './file-upload-fail-dialog.component.html',
    styleUrl: './file-upload-fail-dialog.component.scss'
})
export class FileUploadFailDialogComponent {

    image: any;

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            file: File,
            error: ApiErrorResponse
        }) {
        this.image = URL.createObjectURL(data.file);
    }

    download() {
        saveAs(this.data.file, this.data.file.name);
    }

    retry() {
        this.dialogRef.close(true);
    }

    cancel() {
        this.dialogRef.close();
    }
}
